import { Sparkles } from "lucide-react";
import { Button } from "../ui/button";

export function EmptyState({
  title,
  description,
  actionLabel,
  onAction
}: {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="flex min-h-[55vh] items-center justify-center p-6">
      <div className="app-surface w-full max-w-xl rounded-card p-8 text-center shadow-soft">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-card bg-[color:var(--surface-raised)]">
          <Sparkles className="h-6 w-6 text-[color:var(--primary)]" aria-hidden />
        </div>
        <h2 className="mt-5 text-xl font-bold text-[color:var(--text)]">{title}</h2>
        <p className="mx-auto mt-3 max-w-[48ch] text-sm leading-6 text-[color:var(--muted)]">{description}</p>
        {actionLabel && onAction ? (
          <Button className="mt-6" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
